<div *ngIf="(fetchDates$ | async).fetchFromDate; else noDates">
  <nav attr.aria-label="{{ 'wcag.organizeBookingMenu' | translate }}">
    <ul class="nav nav-tabs align-items-center mb-3" role="tablist">
      <!-- WCAG SKIP link -->
      <!-- <li class="nav-item">
        <a
          class="nav-link visually-hidden-focusable"
          href="#organizeBookingContent"
          >{{ 'wcag.skipNavigation' | translate }}</a
        > </li
      > -->
      <!-- END WCAG skip link -->
      <ng-container *ngFor="let productGroup of productGroups; index as i">
        <li class="nav-item">
          <a
            href="javascript:;"
            (click)="changeSelectedProductGroup(i)"
            data-test-id="organize-bookings-group-tab"
            class="nav-link"
            [ngClass]="{ active: activeTabIndex == i }"
            role="tab"
            [attr.aria-selected]="activeTabIndex == i ? 'true' : 'false '"
          >
            {{ productGroup.description }}
          </a>
        </li>
      </ng-container>
    </ul>
  </nav>

  <div class="mt-3" id="organizeBookingContent">
    <organize-bookings-interface
      [selectedProductGroupId$]="selectedProductGroupId$"
      [startDate]="(fetchDates$ | async).fetchFromDate"
      [endDate]="(fetchDates$ | async).fetchUntilDate"
      [saleBookingIds]="saleBookingIds$ | async"
      [saleId]="saleId"
    ></organize-bookings-interface>
  </div>
</div>
<ng-template #noDates>
  <div class="text-center p-3" data-test-id="organize-bookings-no-dates">
    <h4>{{ 'general.no_participation_sale' | translate }}</h4>
  </div>
</ng-template>
